import React, { Component } from 'react';
import { multiLanguage } from '../../hoc';
import { GradientPage } from '../../components';
import { data, bgImg, logoImg } from '../../data/AboutUs/developer';

@multiLanguage()
export default class Developer extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="aboutus-page-developer">
        <GradientPage image={bgImg} themeWhite>
          <div className="logo-img"><img src={logoImg} alt="" /></div>
          <div className="container-content">{t(data)}</div>
        </GradientPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AboutUs/Developer.js